import { render, staticRenderFns } from "./ControlActividades.vue?vue&type=template&id=47b0a6d0&scoped=true&"
import script from "./ControlActividades.vue?vue&type=script&lang=js&"
export * from "./ControlActividades.vue?vue&type=script&lang=js&"
import style0 from "./ControlActividades.vue?vue&type=style&index=0&id=47b0a6d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0a6d0",
  null
  
)

export default component.exports